export default function DividerMedallion() {
  return (
    <div className="divider-medallion" aria-hidden="true">
      <svg width="46" height="46" viewBox="0 0 46 46">
        <circle cx="23" cy="23" r="21" fill="none" stroke="currentColor" strokeWidth="1" />
        <circle cx="23" cy="23" r="4" fill="currentColor" />
        <path d="M23 2 V10 M23 36 V44 M2 23 H10 M36 23 H44" stroke="currentColor" strokeWidth="1" />
      </svg>
    </div>
  )
}
